export const APPLICATION_IMAGE_STATUSES = [
  { value: "pending", label: "Pending" },
  { value: "approved", label: "Approved" },
  { value: "rejected", label: "Rejected" },
];

export const getApplicationImageStatus = (row) => {
  const raw =
    row?.status ??
    row?.approvalStatus ??
    row?.approval_status ??
    row?.imageStatus;
  if (raw != null && raw !== "") {
    const normalized = String(raw).toLowerCase().trim();
    if (normalized === "approve" || normalized === "accepted") {
      return "approved";
    }
    if (normalized === "reject" || normalized === "declined") {
      return "rejected";
    }
    return normalized;
  }
  if (row?.isActive === true || row?.isActive === "Active") return "approved";
  if (row?.isActive === false || row?.isActive === "Inactive") {
    return "rejected";
  }
  return "pending";
};

export const getApplicationImageStatusClass = (status) => {
  switch (String(status || "").toLowerCase()) {
    case "approved":
    case "active":
      return "status-approved";
    case "pending":
      return "status-pending";
    case "rejected":
    case "inactive":
      return "status-rejected";
    default:
      return "status-default";
  }
};
